import React from 'react';
import { useExperiment } from '@olx/react-laquesis';

import { USER_TYPE } from '../../constants';

import S from './style/SafeDealActionsInfoBlock';
import ActionSafeDeal from './ActionSafeDeal';
import HowSafeDealWorksInfo from '../HowSafeDealWorksModal/HowSafeDealWorksInfo';
import SafeDealExtendedCoverageInfoModal from './SafeDealExtendedCoverageInfoModal';

interface SafeDealActionsInfoBlockProps {
  desktop: boolean;
  trackInfoClick: () => void;
  onAccept: () => void;
  onReject: () => void;
  showOrderSafeDealButtons: boolean;
  userType: USER_TYPE;
  trackingExtras: Record<string, string>;
}

const SafeDealActionsInfoBlock: React.FC<SafeDealActionsInfoBlockProps> = ({
  desktop,
  trackInfoClick,
  onAccept,
  onReject,
  showOrderSafeDealButtons,
  userType,
  trackingExtras,
}) => {
  const isNegotiationsMVPOn = useExperiment('sd-1966') === 'b';
  const getModal = () => {
    if (isNegotiationsMVPOn) {
      return (
        <HowSafeDealWorksInfo
          isDesktop={desktop}
          userType={userType}
          trackingExtras={trackingExtras}
        />
      );
    }

    return (
      <SafeDealExtendedCoverageInfoModal
        desktop={desktop}
        userType={userType}
        trackInfoClick={trackInfoClick}
      />
    );
  };
  return (
    <S.SafeDealActionsInfoBlock data-testid="safedeal-info-block">
      {showOrderSafeDealButtons && <ActionSafeDeal onAccept={onAccept} onReject={onReject} />}
      {getModal()}
    </S.SafeDealActionsInfoBlock>
  );
};

export default SafeDealActionsInfoBlock;
